export const getGeoInfo = () => {
  return fetch("https://ipapi.co/json/")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.log(error);
    });
};
